{
  "version": 1,
  "asset_id": "27b003a2-0d5e-4a33-87d5-bc91c07a5057",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/27b003a2-0d5e-4a33-87d5-bc91c07a5057/sleeve-ugi-reflux-pre-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/27b003a2-0d5e-4a33-87d5-bc91c07a5057/sleeve-ugi-reflux-pre-800.webp",
  "original_filename": "sleeve-ugi-reflux-pre-800.webp",
  "size": 50504,
  "content_type": "image/webp",
  "created_at": "2026-09-28T16:41:41Z"
}
